import React, { ReactElement } from 'react'

import { Header, TripDetails } from '@components/CompactTripCard/'
import { UpdatedMediaData } from '@queries/media'

import '@components/CompactTripCard/TripCardExpanded/styles.scss'

interface CarrierLogo {
  source: string
}
interface ExpandedTripCardProps {
  connection: Connection
  fareClass?: string
  type?: ConnectionType
  carriers?: MarketingCarrier[]
  hideTime?: boolean
  media?: UpdatedMediaData[]
  weeklyConnections?: WeeklyConnectionsParams | null
  carrierLogo: CarrierLogo
}

const ExpandedTripCard = (props: ExpandedTripCardProps): ReactElement => {
  const { connection, carrierLogo } = props

  return (
    <div className="expanded-trip-card">
      {connection.segments.map((segment, index) => {
        const isLastSegment = index == connection.segments.length - 1
        const next = connection.segments[index + 1]
        const previous = connection.segments[index - 1]

        return (
          <>
            <Header
              connection={connection}
              segment={segment}
              carrierLogo={carrierLogo}
              showName={true}
              showLinePrefix={true}
            />
            <TripDetails
              key={segment.id}
              segment={segment}
              next={next}
              previous={previous}
              isLastSegment={isLastSegment}
              connection={connection}
            />
          </>
        )
      })}
    </div>
  )
}

export default ExpandedTripCard
